import { render, staticRenderFns } from "./TopOfTheDayScreen.vue?vue&type=template&id=52085922&scoped=true"
import script from "./TopOfTheDayScreen.vue?vue&type=script&lang=js"
export * from "./TopOfTheDayScreen.vue?vue&type=script&lang=js"
import style0 from "./TopOfTheDayScreen.vue?vue&type=style&index=0&id=52085922&prod&scoped=true&lang=css"
import style1 from "./TopOfTheDayScreen.vue?vue&type=style&index=1&id=52085922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52085922",
  null
  
)

export default component.exports